const urlHost = "//activity.gyyx.cn";
const billingHost = '//apij-billing.gyyx.cn'
// // 接口一
// const modelUrl = urlHost + "/api/modelUrl";

// // 接口二
// const netUrl = urlHost + "/api/netUrl";
//获取登录状态接口
const loginStatusUrl = '//accountv5.gyyx.cn/v1/account/login/status';
//  获取购物车详情接口
const loadshopcartinfoUrl = urlHost + '/wendaoshop/order/loadshopcartinfo';
//  删除购物车接口
const deleteshopcartUrl = urlHost + '/wendaoshop/order/deleteshopcart';
// 加入购物车
const addshopcartUrl = urlHost + '/wendaoshop/order/addshopcart';
// 创建订单接口
const createOrderUrl = urlHost + '/wendaoshop/order/createorder';
// 订单支付接口
const alipayQrcodeUrl = urlHost + '/wendaoshop/alipay/qrcode';
// 获取收获地址列表接口
const getAddressListUrl = urlHost + '/wendaoshop/order/loadmyaddressinfolist';
// 删除地址接口
const deleteaddressinfoUrl = urlHost + '/wendaoshop/order/deleteaddressinfo';
// 编辑地址接口
const editaddressinfoUrl = urlHost + '/wendaoshop/order/editaddressinfo';
// 新增地址接口
const addAddressInfoUrl = urlHost + '/wendaoshop/order/addaddressinfo';
// 点击地址获取运费
const getFreightUrl = urlHost + '/wendaoshop/order/getfreight';
// 支付宝营销
const marketingInfoUrl = urlHost + '/wendaoshop/alipay/getmarketinginfo'
export {
    loadshopcartinfoUrl,//查看购物车详情接口
    loginStatusUrl,//获取登录状态接口
    deleteshopcartUrl,//  删除购物车接口
    addshopcartUrl, // 加入购物车
    createOrderUrl,
    alipayQrcodeUrl,
    getAddressListUrl,
    deleteaddressinfoUrl,
    editaddressinfoUrl,
    addAddressInfoUrl,
    getFreightUrl,
    marketingInfoUrl
};
